(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7748],{

/***/ 59376:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/downloads",
      function () {
        return __webpack_require__(89764);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 78633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common,
    "share-downloads": __webpack_require__(97133),
    "share-downloads-links": __webpack_require__(68678),
    "share-downloads-form": __webpack_require__(61002)
};


/***/ }),

/***/ 56763:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(78633),
    de: __webpack_require__(30393)
};


/***/ }),

/***/ 89764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ downloads; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageTitle/index.js
var PageTitle = __webpack_require__(73446);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/props-resolver.js
var props_resolver = __webpack_require__(77915);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Form/index.js + 1 modules
var Form = __webpack_require__(22950);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/FormField/index.js + 7 modules
var FormField = __webpack_require__(85725);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js + 3 modules
var SimpleTemplate = __webpack_require__(35449);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./src/routes.js + 1 modules
var routes = __webpack_require__(72578);
;// CONCATENATED MODULE: ./src/ShareDownloadsForm/index.js











const ShareDownloadsForm = (param)=>{
    let { regCode  } = param;
    const [t] = (0,i18/* useLocale */.bU)("share-downloads-form");
    /** @type {[string, (value: string) => void]} */ const [code, setCode] = (0,react.useState)(regCode);
    /** @type {[string | null, (value: string | null) => void]} */ const [error, setError] = (0,react.useState)(regCode ? "errors.SERIAL_NUMBER_NOT_VALID" : null);
    const handleInput = (0,react.useCallback)(/** @type {(event: React.ChangeEvent<HTMLInputElement>) => void} */ (event)=>{
        setCode(event.target.value);
        if (error) setError(null); // reseting an error
    }, [
        setCode,
        error
    ]);
    const formSubmit = (0,react.useCallback)(/** @type {(event: React.FormEvent<HTMLFormElement>) => void} */ (event)=>{
        event.preventDefault();
        if (code === "") {
            setError("errors.SERIAL_NUMBER_REQUIRED");
            return;
        }
        (0,routes/* navToPath */.SS)(routes/* refs.support.shareDownloads */.xL.support.shareDownloads({
            r: code.replace(/[^\w]/gi, "")
        }));
    }, [
        code
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleTemplate/* default */.Z, {
        utility: {
            bgColor: "black--02"
        },
        panelPaddingY: 8,
        className: "pt-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("FORM_TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                onSubmit: formSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        utility: {
                            justify: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* default */.Z, {
                                name: "r",
                                label: t("FORM_LABEL"),
                                value: code,
                                onChange: handleInput,
                                required: true,
                                error: error && t(error)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        utility: {
                            justify: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            sm: 12,
                            md: 8,
                            sx: {
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "submit",
                                spacing: {
                                    mt: 10
                                },
                                size: "m",
                                children: t("FORM_SUBMIT_BUTTON")
                            })
                        })
                    })
                ]
            })
        ]
    });
};
ShareDownloadsForm.propTypes = {
    regCode: prop_types.string.isRequired
};
/* harmony default export */ var src_ShareDownloadsForm = (ShareDownloadsForm);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/ShareDownloads/index.js
var ShareDownloads = __webpack_require__(68804);
// EXTERNAL MODULE: ./src/graphql/queries/getSubscriptionsList.js
var getSubscriptionsList = __webpack_require__(94988);
;// CONCATENATED MODULE: ./src/ShareDownloads/ShareDownloadsLinkItem.js





const ShareDownloadLinkItem = (param)=>{
    let { os , downloadLink  } = param;
    const [t] = (0,i18/* useLocale */.bU)("share-downloads-links");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloads/* ShareDownloadsButtonCol */.XV, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloads/* ShareDownloadsButton */.Vr, {
            href: "".concat(downloadLink),
            iconName: os,
            children: t("".concat(os.toUpperCase(), ".TITLE"))
        })
    });
};
ShareDownloadLinkItem.propTypes = {
    os: prop_types.string,
    downloadLink: prop_types.string
};
/* harmony default export */ var ShareDownloadsLinkItem = (ShareDownloadLinkItem);

;// CONCATENATED MODULE: ./src/ShareDownloads/ShareDownloadsLinks.js






const renderDownloadLink = (download)=>download != null && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloadsLinkItem, {
        ...download
    });
const ShareDownloadLinks = (param)=>{
    let { items , productVersion  } = param;
    const [t] = (0,i18/* useLocale */.bU)("share-downloads-links");
    const downloads = react.useMemo(()=>new Map(items.map((item)=>[
                item.os,
                item
            ])), [
        items
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloads/* ShareDownloadsParagraph */.YZ, {
                className: "mb-10",
                children: t("TITLE", {
                    version: productVersion
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareDownloads/* ShareDownloadsButtonsContainer */.bw, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareDownloads/* ShareDownloadsButtonsRow */.LI, {
                        children: [
                            renderDownloadLink(downloads.get("mac")),
                            renderDownloadLink(downloads.get("windows"))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareDownloads/* ShareDownloadsButtonsRow */.LI, {
                        children: [
                            renderDownloadLink(downloads.get("linux_deb")),
                            renderDownloadLink(downloads.get("linux_rpm"))
                        ]
                    })
                ]
            })
        ]
    });
};
ShareDownloadLinks.propTypes = {
    items: (0,prop_types.arrayOf)((0,prop_types.shape)({
        os: prop_types.string,
        id: prop_types.string,
        minOSVersion: prop_types.string,
        minOSName: prop_types.string,
        downloadLink: prop_types.string
    })).isRequired,
    productVersion: prop_types.string.isRequired
};
/* harmony default export */ var ShareDownloadsLinks = (ShareDownloadLinks);

;// CONCATENATED MODULE: ./src/ShareDownloads/ShareDownloadsMinVersion.js





const ShareDownloadsMinVersion = (param)=>{
    let { items  } = param;
    const downloads = react.useMemo(()=>new Map(items.map((item)=>[
                item.os,
                item
            ])), [
        items
    ]);
    const [t] = (0,i18/* useLocale */.bU)("share-downloads-links");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloads/* ShareDownloadsParagraphWrapper */.bd, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareDownloads/* ShareDownloadsParagraph */.YZ, {
                color: "black--20",
                children: [
                    "*",
                    " ",
                    t("".concat(downloads.get("mac").os.toUpperCase(), ".REQUIREMENTS"), {
                        version: downloads.get("mac").minOSVersion,
                        name: downloads.get("mac").minOSName
                    }),
                    ",",
                    " ",
                    t("".concat(downloads.get("windows").os.toUpperCase(), ".REQUIREMENTS"), {
                        version: downloads.get("windows").minOSVersion,
                        name: downloads.get("windows").minOSName
                    })
                ]
            })
        })
    });
};
ShareDownloadsMinVersion.propTypes = {
    items: (0,prop_types.arrayOf)((0,prop_types.shape)({
        os: prop_types.string,
        id: prop_types.string,
        minOSVersion: prop_types.string,
        minOSName: prop_types.string,
        downloadLink: prop_types.string
    })).isRequired
};
/* harmony default export */ var ShareDownloads_ShareDownloadsMinVersion = (ShareDownloadsMinVersion);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Line/index.js + 1 modules
var Line = __webpack_require__(15945);
// EXTERNAL MODULE: ./src/utils/format-serial-number.js
var format_serial_number = __webpack_require__(88976);
;// CONCATENATED MODULE: ./src/ShareDownloads/ShareDownloadsSubscriotionInfo.js







const ShareDownloadsSubscriptionInfo = (param)=>{
    let { serialNumber  } = param;
    var ref;
    const [t] = (0,i18/* useLocale */.bU)("share-downloads");
    var ref1;
    const planCode = serialNumber.isBeta ? "sg_beta_license" : serialNumber.isDeveloper ? "sg_developer_license" : (ref1 = serialNumber === null || serialNumber === void 0 ? void 0 : (ref = serialNumber.plan) === null || ref === void 0 ? void 0 : ref.planCode) !== null && ref1 !== void 0 ? ref1 : "sg_permanent_license";
    var _expirationDate;
    const dateEnd = (_expirationDate = serialNumber.expirationDate) !== null && _expirationDate !== void 0 ? _expirationDate : serialNumber.supportExpirationDate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloads/* ShareDownloadsHeading */.QE, {
                children: t("DOWNLOAD_SNAPGENE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloads/* ShareDownloadsParagraph */.YZ, {
                className: "mt-10 mb-0",
                children: t("GROUP_NAME", {
                    groupName: serialNumber.licenseName
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloads/* ShareDownloadsParagraph */.YZ, {
                className: "pb-0 my-1",
                children: t("REG_CODE", {
                    regCode: (0,format_serial_number/* default */.Z)(serialNumber.serialNumber)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloads/* ShareDownloadsParagraph */.YZ, {
                className: "mb-10 mt-0",
                children: planCode !== "sg_permanent_license" ? t(planCode, {
                    expirationDate: dateEnd
                }) : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                spacing: {
                    mb: 10
                }
            })
        ]
    });
};
ShareDownloadsSubscriptionInfo.propTypes = {
    serialNumber: getSubscriptionsList/* subscriptionPropTypes */.wB
};
/* harmony default export */ var ShareDownloadsSubscriotionInfo = (ShareDownloadsSubscriptionInfo);

;// CONCATENATED MODULE: ./src/ShareDownloads/ShareDownloadsInfo.js







function ShareDownloadsInfo(param) {
    let { serialNumber  } = param;
    const productVersion = serialNumber.downloads[0].release || "";
    const { downloads  } = serialNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareDownloads/* ShareDownloadsPageWrapper */.mL, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloadsSubscriotionInfo, {
                serialNumber: serialNumber
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloads/* ShareDownloadsButtonsContainer */.bw, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloadsLinks, {
                    items: downloads,
                    productVersion: productVersion
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloads_ShareDownloadsMinVersion, {
                items: downloads
            })
        ]
    });
}
ShareDownloadsInfo.propTypes = {
    serialNumber: getSubscriptionsList/* subscriptionPropTypes */.wB
};
/* harmony default export */ var ShareDownloads_ShareDownloadsInfo = (ShareDownloadsInfo);

// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(3918);
// EXTERNAL MODULE: ./src/apollo/index.js + 14 modules
var apollo = __webpack_require__(75469);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 15 modules
var lib = __webpack_require__(4969);
;// CONCATENATED MODULE: ./src/graphql/queries/getSerialNumberByCode.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	query getSerialNumberByCode($serialNumber: String!) {\n		getSerialNumberByCode(serialNumber: $serialNumber) {\n			licenseName\n			serialNumber\n			isBeta\n			isDeveloper\n			expirationDate\n			supportExpirationDate\n			plan {\n				planCode\n			}\n			subscriptionID\n			downloads {\n				id\n				os\n				release\n				releaseDate\n				architectures\n				minOSVersion\n				minOSName\n				downloadLink\n			}\n		}\n	}\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var getSerialNumberByCode = ((0,lib/* default */.ZP)(_templateObject()));
const readSerialNumberByCode = (param)=>{
    let { data  } = param;
    return data && data.getSerialNumberByCode;
};

;// CONCATENATED MODULE: ./src/services/serialNumber.js


/** @type {(context: object, serialNumber: string) => Promise<object | null>} */ const getSerialNumberInfo = (context, serialNumber)=>serialNumber ? (0,apollo/* default */.Z)(context).query({
        query: getSerialNumberByCode,
        variables: {
            serialNumber
        }
    }).then(readSerialNumberByCode) : Promise.resolve(null);

// EXTERNAL MODULE: ./locales/downloads-page/index.js
var downloads_page = __webpack_require__(56763);
var downloads_page_default = /*#__PURE__*/__webpack_require__.n(downloads_page);
;// CONCATENATED MODULE: ./pages/support/downloads.js













const DownloadsPageHead = (param)=>{
    let { regCode  } = param;
    const [t] = (0,i18/* useLocale */.bU)("share-downloads");
    if (regCode.length > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
            title: t("PAGE_TITLE"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Robots */.ZP.Robots, {
                    content: t("META_ROBOTS_CONTENT")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                    href: t("META_CANONICAL")
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
        title: t("PAGE_TITLE")
    });
};
const Downloads = (param)=>{
    let { serialNumber , regCode  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadsPageHead, {
                regCode: regCode
            }),
            serialNumber !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareDownloads_ShareDownloadsInfo, {
                serialNumber: serialNumber
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(src_ShareDownloadsForm, {
                regCode: regCode
            }, Date.now()) // force re-render on page reload
        ]
    });
};
var _r;
const regCode = (param)=>{
    let { query  } = param;
    return (_r = query.r) !== null && _r !== void 0 ? _r : "";
};
Downloads.getInitialProps = (0,props_resolver/* default */.Z)({
    serialNumber: (context)=>getSerialNumberInfo(context, regCode(context)),
    regCode
});
Downloads.propTypes = {
    serialNumber: prop_types.object,
    regCode: prop_types.string
};
DownloadsPageHead.propTypes = {
    regCode: prop_types.string
};
/* harmony default export */ var downloads = ((0,pipe/* default */.Z)(Downloads, (0,i18/* WithLocale */._t)({
    resources: (downloads_page_default())
})));


/***/ }),

/***/ 88976:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const formatSerialNumber = (serialNumber)=>!/[_-]/.test(serialNumber) // if contains dash or underscore skip formatting
     ? serialNumber.replace(/(.{4})/g, "-$1").slice(1) : serialNumber;
/* harmony default export */ __webpack_exports__["Z"] = (formatSerialNumber);


/***/ }),

/***/ 61002:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"FORM_TITLE":"Please enter your registration code:","FORM_LABEL":"REGISTRATION CODE:","FORM_SUBMIT_BUTTON":"Submit","errors":{"SERIAL_NUMBER_REQUIRED":"This field is required.","SERIAL_NUMBER_NOT_VALID":"Please enter a valid registration code."}}');

/***/ }),

/***/ 68678:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TITLE":"SnapGene {{version}} is the latest version available for your license:","MAC":{"TITLE":"macOS","REQUIREMENTS":"macOS requires macOS {{version}} ({{name}}) or higher"},"LINUX_RPM":{"TITLE":"CentOS / RedHat","REQUIREMENTS":""},"LINUX_DEB":{"TITLE":"Ubuntu","REQUIREMENTS":""},"WINDOWS":{"TITLE":"Windows","REQUIREMENTS":"Windows requires {{name}} or higher"}}');

/***/ }),

/***/ 97133:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"PAGE_TITLE":"Downloads - SnapGene","DOWNLOAD_SNAPGENE":"Download SnapGene","GROUP_NAME":"Group name: {{groupName}}","REG_CODE":"Registration Code: {{regCode}}","META_CANONICAL":"https://www.snapgene.com/support/downloads","META_ROBOTS_CONTENT":"noindex","sg_floating_academic_yearly":"This is a shared subscription account good through {{expirationDate,LONGDATE}}.","sg_floating_corporate_yearly":"This is a shared subscription account good through {{expirationDate,LONGDATE}}.","sg_network_academic_yearly":"This is a network subscription account good through {{expirationDate,LONGDATE}}.","sg_network_corporate_yearly":"This is a network subscription account good through {{expirationDate,LONGDATE}}.","sg_server_academic_yearly":"This is a server account good through {{expirationDate,LONGDATE}}.","sg_server_corporate_yearly":"This is a server account good through {{expirationDate,LONGDATE}}.","sg_academic_yearly":"This is a subscription account good through {{expirationDate,LONGDATE}}.","sg_corporate_yearly":"This is a subscription account good through {{expirationDate,LONGDATE}}.","sg_student_yearly":"This is a subscription account good through {{expirationDate,LONGDATE}}.","sg_permanent_license":"This is a permanent license with updates through {{expirationDate,LONGDATE}}.","sg_beta_license":"This is a beta_tester account good through {{expirationDate,LONGDATE}}.","sg_developer_license":"This is a developer account good through {{expirationDate,LONGDATE}}.","sg_default_license_description":"This is a subscription account good through {{expirationDate,LONGDATE}}.","sg_personal_monthly":"This is a trial subscription good through {{expirationDate,LONGDATE}}."}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,5606,8124,6885,2458,3918,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(59376); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);